// extracted by mini-css-extract-plugin
export default {"section-container":"Rt5s3umn8KHjPQnSjFdX","section-content":"Ab7_WrTCSxr8vSXGRbJC","checkbox-group-label":"mcFU2A2tMm13F1dqkRrM","checkbox-group":"gfM5b7KEiQ98cxmOulwA"};